import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleCategoryVisibility } from '../filterListSlice';
interface CategoryProps {
  name: string;
  closed: boolean;
  index: number;
  icon?: string;
  children: any;
}

export default ({ name, icon, closed, index, children }: CategoryProps) => {
  const dispatch = useDispatch();
  return (
    <div className='tour__filter'>
      <div
        className='tour__filter__header'
        onClick={() => dispatch(toggleCategoryVisibility(index))}
      >
        {icon ? (
          <>
            <i className={icon} />
            &nbsp;
          </>
        ) : null}
        <span>{name}</span>
        <i className={closed ? 'fas fa-caret-up' : 'fas fa-caret-down'} />
      </div>
      {!closed ? <div className='tour__filter__body'>{children}</div> : null}
    </div>
  );
};
